import styled, { keyframes } from 'styled-components';

const banner = ({
  theme: { colors = {} },
}: {
  theme: { colors?: Record<string, string | undefined> };
}) => ({
  bg: colors.errorContainer ?? '#5C1F2A',
  fg: colors.onErrorContainer ?? '#FFB4AB',
  border: colors.error ?? '#FF7A8A',
  buttonBg: colors.error ?? '#FF7A8A',
  buttonFg: colors.onError ?? '#410002',
  spinnerFg: colors.onErrorContainer ?? '#FFB4AB',
});

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const BannerRoot = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: ${(p) => banner(p).bg};
  color: ${(p) => banner(p).fg};
  border: 1px solid ${(p) => banner(p).border};
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.32);
  max-width: 640px;
  font-size: 13px;
`;

export const BannerTitle = styled.strong`
  font-weight: 600;
`;

export const BannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
`;

export const BannerButton = styled.button`
  appearance: none;
  background: ${(p) => banner(p).buttonBg};
  color: ${(p) => banner(p).buttonFg};
  border: 0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    filter: brightness(1.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ReconnectingSpinner = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid ${(p) => banner(p).spinnerFg};
  border-top-color: transparent;
  animation: ${spin} 0.9s linear infinite;
  flex-shrink: 0;
`;
